(() => {
  'use strict';

  // Textos traducidos que entrega layout/theme.liquid (window.DYStrings); español como respaldo
  const dyT = (key, fallback) => (window.DYStrings && window.DYStrings[key]) || fallback;

  function moneyFromEl(el) {
    if (!el) return '';
    return el.textContent.replace(/\s+/g, ' ').trim();
  }

  function formatAtc(btn) {
    if (!btn || btn.dataset.dyAtcBound === '1') return;
    if (btn.closest('quick-add-component, .quick-add, product-card, .product-card')) {
      const label = btn.querySelector('.add-to-cart-text__content span span, .add-to-cart-text__content');
      if (label) {
        const isChoose = btn.classList.contains('quick-add__button--choose');
        label.textContent = isChoose
          ? dyT('choose_options', 'Elegir opciones')
          : dyT('add_to_bag', 'Añadir a la bolsa');
      }
      btn.dataset.dyAtcBound = '1';
      return;
    }
    const root =
      btn.closest('.product-information, .product-details, product-information, .buy-buttons-block') ||
      document;
    const priceEl = root.querySelector(
      '.price__regular .price-item--regular, .price .price-item--regular, .price__sale .price-item--sale, .price'
    );
    const price = moneyFromEl(priceEl);
    const label = btn.querySelector('.add-to-cart-text__content span span, .add-to-cart-text__content');
    if (!label) {
      btn.dataset.dyAtcBound = '1';
      return;
    }
    const addLabel = dyT('add_to_bag', 'Añadir a la bolsa');
    label.textContent = price ? `${addLabel} • ${price}` : addLabel;
    btn.dataset.dyAtcBound = '1';
    const icon = btn.querySelector('.add-to-cart-icon');
    if (icon) icon.style.display = 'none';
  }

  function run() {
    document.querySelectorAll('button[name="add"], .add-to-cart-button').forEach(formatAtc);
  }

  function init() {
    run();
    document.addEventListener('variant:change', () => {
      document.querySelectorAll('button[name="add"]').forEach((b) => delete b.dataset.dyAtcBound);
      setTimeout(run, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
